import { marusiaApi } from 'api';
import { Api } from 'api/otvety';
import { logInfo } from 'utils/logging';
import { getCSRFTOKEN } from '../../../utils/cookie/getCSRFToken';

const postMarusiaComplain = async (
  slug: string,
): Promise<Api.PostMarusiaComplain200Response> => {
  const csrf_token = getCSRFTOKEN('OTVETY-CSRF-TOKEN') || '';
  return await marusiaApi()
    .postMarusiaComplain(slug, csrf_token)
    .then((res) => res)
    .catch((error) => {
      logInfo(error.toString(), true);
      return { success: false };
    });
};

export default postMarusiaComplain;
